import KoreAnalyticsHandler from "./KoreAnalyticsHandler";

/**
 * Class to manage the chat bot interactions and the Adobe API handler.
 */
export default class KoreAnalyticsManager {
    constructor() {
        this.analyticsHandler = new KoreAnalyticsHandler();
    }

    rolAskUsClicked() {
        this.analyticsHandler.askUsClicked();
    }

    userClosedChatWindow() {
        this.analyticsHandler.chatWindowClosed();
    }

    userOpenedChatWindow() {
        this.analyticsHandler.chatWindowOpened();
    }

    userSentMessage() {
        this.analyticsHandler.chatMessageSent();
    }
}